import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Table } from "../../../Table/Table";
import Loading from "../../../Loadings/LoadingTable";
import { MdDeleteForever } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { RowElement, RowLayoutStyle } from "../../Sliders/AddSlide";

import { MdNotificationsActive } from "react-icons/md";
import Button from "../../../Button/Button";
import {
  useGetOccationList,
  useChangeOccationStatus,
} from "../../../../hooks/useContent";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  ContentUnitModal,
  RefreshTableOccation,
} from "../../../../shared/content-unit";
import { MdSubtitles } from "react-icons/md";
import Spinner from "react-bootstrap/Spinner";
import EditSeo from "../../../Dialog/contentUnit/EditSeo";
import { RenderTooltip } from "../../../Tooltip/Tooltip";

function OccationTable() {
  const [refresh, setRefreshEffect] = useRecoilState(RefreshTableOccation);

  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");
  const [showSeo, setShowSeo] = useState(false);
  const [currentSeo, setCurrentSeo] = useState({});

  const { data, isLoading, refetch, fetchNextPage, hasNextPage } =
    useGetOccationList(pageNumber, search);

  const {
    mutateAsync: updateStatus,
    isLoading: upLoading,
    error: upError,
  } = useChangeOccationStatus();

  const [moduals, setModuals] = useRecoilState(ContentUnitModal);
  let categoryList = data?.data?.occasion;
  let pageCount = data?.pages[0]?.data?.count;

  const [idOccation, setIdOccation] = useState(-1);

  useEffect(() => {
    refetch(pageNumber);
    categoryList = [];
  }, [refresh]);

  const headerTitle = [
    "#",
    "نام مناسبت",
    "نام مناسبت انگلیسی",
    "نام مناسبت عربی",
    "وضعیت",
    "نوع",
    "عملیات",
  ];

  const handleDeleteCatergory = (category) => {
    setModuals({
      ...moduals,
      deleteOccation: { value: category, isShow: true },
    });
  };

  const handleUpdateCategory = (item) => {
    setModuals({ ...moduals, updateOccation: { value: item, isShow: true } });
  };

  const handleUpdateSEO = (item) => {
    setShowSeo(true);
    setCurrentSeo(item);
  };

  const handleChangeSatus = (item) => {
    setIdOccation(item?.IdOccasions);
    updateStatus(item?.IdOccasions).then((res) => {
      setRefreshEffect(!refresh);
    });
  };

  // handle next page
  const handleNext = () => {
    if (pageNumber < pageCount) setPageNumber((prevState) => prevState + 1);
  };

  // handle previos page
  const handlePrevios = () => {
    if (pageNumber === 1) {
      setPageNumber(1);
    } else {
      setPageNumber((prevState) => prevState - 1);
    }
  };

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  let i = 0;

  const items = data ? (
    data?.pages?.map((page) =>
      page?.data?.occasion?.map((item, index) => {
        return (
          <tr key={index}>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {(i += 1)}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.OccasionsFarsi ? item?.OccasionsFarsi : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.OccasionsEnglish ? item?.OccasionsEnglish : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.OccasionsLanguage ? item?.OccasionsLanguage : ""}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.StatusOccasions === "Active" ? "فعال" : "غیر فعال"}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.TypeOccasions}
              </span>
            </td>
            <td>
              <ButtonContainer>
                <RenderTooltip title={"حذف  مناسبت"}>
                  <Button
                    size="12px"
                    bgColor="#C82333"
                    small="40px"
                    color="#fff"
                    style={{
                      marginLeft: "1rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onclick={(e) => {
                      handleDeleteCatergory(item);
                    }}
                  >
                    <MdDeleteForever size={25} />
                  </Button>
                </RenderTooltip>
                <RenderTooltip title={"ویرایش  مناسبت"}>
                  <Button
                    size="12px"
                    bgColor="#0D6EFD"
                    small="40px"
                    color="#fff"
                    className="mr-2"
                    onclick={(e) => {
                      handleUpdateCategory(item);
                    }}
                  >
                    <FiEdit size={20} />
                  </Button>
                </RenderTooltip>
                <RenderTooltip
                  title={
                    item?.StatusOccasions === "Active"
                      ? "غیرفعال کردن"
                      : "فعال کردن"
                  }
                >
                  <Button
                    size="12px"
                    bgColor={
                      item?.StatusOccasions === "Active" ? "#80575B" : "#50CD89"
                    }
                    small="40px"
                    color="#fff"
                    className="mr-2"
                    onclick={(e) => {
                      handleChangeSatus(item);
                    }}
                  >
                    {upLoading && idOccation === item?.IdOccasions ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <MdNotificationsActive size={20} />
                    )}
                  </Button>
                </RenderTooltip>
                <RenderTooltip title={"ویرایش  سِو"}>
                  <Button
                    size="12px"
                    bgColor="#575b92"
                    small="40px"
                    color="#fff"
                    onclick={(e) => {
                      handleUpdateSEO(item);
                    }}
                  >
                    <MdSubtitles size={20} />
                  </Button>
                </RenderTooltip>
              </ButtonContainer>
            </td>
          </tr>
        );
      })
    )
  ) : (
    <Loading />
  );

  return (
    <CategoryTableStyle>
      <Table
        headerTitle={headerTitle}
        title={`مناسبت هایی که تاکنون ثبت کرده اید : ${
          pageCount ? pageCount : ""
        }`}
        items={items}
        setSearch={setSearch}
      />
      <EditSeo
        show={showSeo}
        IdRefrenceSeo={currentSeo?.IdOccasions}
        handleClose={() => {
          setShowSeo(false);
        }}
        locationSeo="Occasion"
        item={currentSeo}
      />
    </CategoryTableStyle>
  );
}

const CategoryTableStyle = styled.div`
  width: 100%;
  margin-top: 1rem;

  .slider-image-table {
    width: 90px;
    height: 60px;
    object-fit: contain;
    border-radius: 0.5rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  gap: 1rem;
`;

export default OccationTable;
